// extracted by mini-css-extract-plugin
module.exports =  {"root":"fAcCFts70AwG4xFOajfu","suffix":"tZScCi6pzZfvZt4m2BdA"};